export enum SUPPORTED_LANGUAGE {
  PL = 'pl',
  EN = 'en',
}
